import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

export const EInvoicingAlert = () => (
    <div className='alert alert-info margin-bottom-25'>
        <div className='display-flex gap-10'>
            <span className='text-color-info text-size-h4 rioglyph rioglyph-info-sign' />
            <div>
                <span className='text-size-16'>
                    <FormattedMessage
                        id={'invoices.eInvoicing.alert.title'}
                        values={{
                            b: chunks => <b>{chunks}</b>,
                        }}
                    />
                </span>
                <p className='margin-y-5'>
                    <FormattedMessage
                        id={'invoices.eInvoicing.alert.description1'}
                        values={{
                            b: chunks => <b>{chunks}</b>,
                        }}
                    />
                </p>
                <p className='margin-bottom-0'>
                    <FormattedMessage
                        id={'invoices.eInvoicing.alert.description2'}
                        values={{
                            b: chunks => <b>{chunks}</b>,
                            link: msg => (
                                <Link
                                    to='/administration/contract?tab=invoicing'
                                    className='text-color-black text-decoration-underline text-medium'
                                >
                                    {msg}
                                </Link>
                            ),
                        }}
                    />
                </p>
            </div>
        </div>
    </div>
);
